import type { DPCalendar } from '@rehookify/datepicker';
import { useCalendars } from '@rehookify/datepicker';
import { DateTime } from 'luxon';
import { use } from 'react';
import { FormattedDateTime } from '../formatted/index.ts';
import { Heading } from '../Heading/index.ts';
import { DatePickerContext } from './DatePickerContext.ts';
import { DatePickerDay } from './DatePickerDay.tsx';

export function DatePickerMonth({ calendar }: { calendar: DPCalendar }) {
  const { dpState } = use(DatePickerContext);
  const { weekDays } = useCalendars(dpState);

  const firstDay = calendar.days.find(day => day.inCurrentMonth)!.$date;

  return (
    <div>
      <div className="mb-6 flex h-10 flex-col justify-center text-center">
        <Heading level={6}>
          <FormattedDateTime
            dateStyle="long"
            showDay={false}
            showMonth
            showYear
            value={DateTime.fromJSDate(firstDay)}
          />
        </Heading>
      </div>
      <div className="mb-3 grid grid-cols-7 text-xs font-medium text-gray-500">
        {weekDays.map((dayLabel, index) => (
          // oxlint-disable-next-line react/no-array-index-key
          <div key={index} className="text-center">
            {dayLabel}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-y-1">
        {calendar.days.map(day => {
          return <DatePickerDay key={day.$date.toISOString()} day={day} />;
        })}
      </div>
    </div>
  );
}
